module.exports = __webpack_public_path__ + "static/media/logo-mini.bbee2600.svg";